import { ConversationTitle } from '@types';
import { SyncState } from '@sonar-software/xuder';

export type CoreAgentConversationTitlesState = SyncState<Record<number, ConversationTitle>>;

export const defaultAgentConversationTitlesState: CoreAgentConversationTitlesState = { data: {} };
